import React from "react";
var __jsx = React.createElement;
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@/components/modal";
import { Button } from "@/components/button";
import { FormDateTime } from "@/components/form";
import { trackEvent, ANALYTICS_EVENTS } from "@/utils/analytics";
import { meanDateTime } from "./lkw-mean";
/** Computes a last-known-well time as the midpoint of two datetimes. */
export function LkwCalculatorModal(_ref) {
  var opened = _ref.opened,
    onClose = _ref.onClose,
    onSave = _ref.onSave;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(""),
    first = _useState[0],
    setFirst = _useState[1];
  var _useState2 = useState(""),
    second = _useState2[0],
    setSecond = _useState2[1];
  var save = function save() {
    trackEvent(ANALYTICS_EVENTS.LKW_CALC_SAVE);
    if (!first || !second) return;
    onSave(meanDateTime(first, second));
    onClose();
  };
  return /*#__PURE__*/React.createElement(Modal, {
    opened: opened,
    onClose: onClose,
    size: "md",
    title: t("lkw_calc_title", {
      defaultValue: "Calculate last-known-well time"
    }),
    closeTestId: "lkw-calc-close",
    footer: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      variant: "ghost",
      "data-testid": "lkw-calc-cancel",
      onClick: function onClick() {
        trackEvent(ANALYTICS_EVENTS.LKW_CALC_CANCEL);
        onClose();
      }
    }, t("cancel", {
      defaultValue: "Cancel"
    })), /*#__PURE__*/React.createElement(Button, {
      "data-testid": "lkw-calc-save",
      disabled: !first || !second,
      onClick: save
    }, t("save", {
      defaultValue: "Save"
    })))
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement(FormDateTime, {
    label: t("lkw_last_seen_well", {
      defaultValue: "Patient last seen well"
    }),
    value: first,
    onChange: setFirst,
    testId: "lkw-first"
  }), /*#__PURE__*/React.createElement(FormDateTime, {
    label: t("lkw_symptoms_discovered", {
      defaultValue: "Symptoms discovered"
    }),
    value: second,
    onChange: setSecond,
    testId: "lkw-second"
  })));
}